/* ============================================================
   OFFKEY LONDON — Header behaviour
   - Hover behaviour is handled in pure CSS.
   - JS handles: scroll-to-solid, mobile hamburger, drawer.
   ============================================================ */
(function () {
  const init = () => {
    const header = document.querySelector('.offkey-header');
    if (!header) {
      console.warn('[OFFKEY] .offkey-header not found — did the Liquid edit save?');
      return;
    }
    const headerEl = header.querySelector('header.header') || header;
    // Keep page padding in sync with actual header height
const setHeaderHeightVar = () => {
  document.documentElement.style.setProperty('--offkey-header-height', header.offsetHeight + 'px');
};
setHeaderHeightVar();
window.addEventListener('resize', setHeaderHeightVar);
window.addEventListener('load', setHeaderHeightVar);

    // ---------- 1. Inject mobile hamburger ----------
    const toggle = document.createElement('button');
    toggle.className = 'offkey-mobile-toggle';
    toggle.type = 'button';
    toggle.setAttribute('aria-label', 'Open menu');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square">' +
      '<line x1="3" y1="6"  x2="21" y2="6"/>' +
      '<line x1="3" y1="12" x2="21" y2="12"/>' +
      '<line x1="3" y1="18" x2="21" y2="18"/>' +
      '</svg>';
    headerEl.prepend(toggle);

    // ---------- 2. Inject drawer + backdrop ----------
    const inlineMenu = header.querySelector('.header__inline-menu');
    let menuLinksHTML = '';
    if (inlineMenu) {
      inlineMenu.querySelectorAll('a.header__menu-item').forEach((link) => {
        const text = (link.textContent || '').trim();
        const href = link.getAttribute('href') || '#';
        menuLinksHTML += '<li><a href="' + href + '">' + text + '</a></li>';
      });
    }

    const drawer = document.createElement('aside');
    drawer.className = 'offkey-mobile-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.innerHTML =
      '<div class="offkey-mobile-drawer__head">' +
        '<span class="offkey-mobile-drawer__title">Menu</span>' +
        '<button type="button" class="offkey-mobile-drawer__close" aria-label="Close menu">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square">' +
          '<line x1="6"  y1="6" x2="18" y2="18"/>' +
          '<line x1="18" y1="6" x2="6"  y2="18"/>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<ul class="offkey-mobile-drawer__menu">' + menuLinksHTML + '</ul>';
    document.body.appendChild(drawer);

    const backdrop = document.createElement('div');
    backdrop.className = 'offkey-mobile-backdrop';
    document.body.appendChild(backdrop);

    const closeBtn = drawer.querySelector('.offkey-mobile-drawer__close');

    // ---------- 3. Drawer open / close ----------
    let lastFocused = null;
    const openDrawer = () => {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.classList.add('offkey-drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      const first = drawer.querySelector('a, button');
      if (first) first.focus();
    };
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.classList.remove('offkey-drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    toggle.addEventListener('click', openDrawer);
    backdrop.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // ---------- 4. Solid-on-scroll ----------
    const isHomepage = document.body.classList.contains('template-index');
    const hero = document.querySelector('.offkey-hero');

    const apply = () => {
      if (!isHomepage) {
        header.classList.add('is-solid');
        return;
      }
      if (hero) {
        const rect = hero.getBoundingClientRect();
        if (rect.bottom - header.offsetHeight < 0) header.classList.add('is-solid');
        else header.classList.remove('is-solid');
      } else {
        if (window.scrollY > 50) header.classList.add('is-solid');
        else header.classList.remove('is-solid');
      }
    };

    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply, { passive: true });
    apply();

    console.log('[OFFKEY] header initialised', { isHomepage, hasHero: !!hero });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();